/**
 * Initialize the 'ui.featureFlags' state.
 *
 * @type {Object}
 */
const INITIAL_STATE = {
    isHybridSsoEnabled: false,
    isAdministrationOptionEnabled: false,
    isAcaAdmin: false,
    isACAReportingEnabled: false,
    isPCORIReportingEnabled: false,
    hasAccessToHandbookMoveTool: false,
    isImpartnerEnabled: false,
    isACAParentPartnerAdminFeatureEnabled: false,
};

export default INITIAL_STATE;
